module.exports = __webpack_public_path__ + "static/media/jm.5a6257a6.svg";